module.exports = __webpack_public_path__ + "img/presentation.52596b48.webp";